module.exports = __webpack_public_path__ + "static/media/17_digginglight.51fa38c8.jpg";